// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__RecoletaSemiBold_adf946', '__RecoletaSemiBold_Fallback_adf946', Georgia, serif","fontWeight":600,"fontStyle":"normal"},"className":"__className_adf946"};